import { useIntl } from 'react-intl';
import AntdFormItem from '../../../../../../../components/AntdFormItem';
import AntdInput from '../../../../../../../components/AntdInput';

const LaboratoryFormFields = () => {
  const intl = useIntl();
  return (
    <>
      <div className="col-sx-12 col-md-3">
        <AntdFormItem
          name="templateName"
          label={intl.formatMessage({
            id: 'pages.quality.ocr.templates.create.delivery.templateLayout.field.templateName',
          })}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: 'validations.required' }),
            },
          ]}
        >
          <AntdInput size="large" />
        </AntdFormItem>
      </div>
      <div className="col-sx-12 col-md-3">
        <AntdFormItem
          name="supplier_id"
          label={intl.formatMessage({
            id: 'pages.quality.ocr.templates.create.delivery.templateLayout.field.supplier_id',
          })}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: 'validations.required' }),
            },
          ]}
        >
          <AntdInput size="large" />
        </AntdFormItem>
      </div>
      <div className="col-sx-12 col-md-3">
        <AntdFormItem
          name="phone_number"
          label={intl.formatMessage({
            id: 'pages.quality.ocr.templates.create.delivery.templateLayout.field.phone_number',
          })}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: 'validations.required' }),
            },
            {
              pattern: /^\+?[1-9]\d{1,14}$/,
              message: intl.formatMessage({ id: 'validations.phone' }),
            },
          ]}
        >
          <AntdInput size="large" />
        </AntdFormItem>
      </div>
      <div className="col-sx-12 col-md-3">
        <AntdFormItem
          name="email"
          label={intl.formatMessage({
            id: 'pages.quality.ocr.templates.create.delivery.templateLayout.field.email',
          })}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: 'validations.required' }),
            },
            {
              type: 'email',
              message: intl.formatMessage({ id: 'validations.email' }),
            },
          ]}
        >
          <AntdInput size="large" />
        </AntdFormItem>
      </div>
    </>
  );
};

export default LaboratoryFormFields;
